import { useMutation, useQueryClient } from "react-query";
import { updateClientPersonalInfo } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";
import { GET_CLIENTS } from "@constants/reactQueryKeys";

interface UpdateClientPersonalInfoPayload {
  clientId: string;
  data: Record<string, any>;
}

export const useUpdateClientPersonalInfo = (options: any = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();
  const queryClient = useQueryClient();

  const { mutate, isLoading, ...rest } = useMutation(
    (payload: UpdateClientPersonalInfoPayload) => updateClientPersonalInfo(payload),
    {
      onSuccess: (response, variables) => {
        showToast("Client information updated successfully", "success");
        
        queryClient.invalidateQueries([GET_CLIENTS]);
        
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.error || "Failed to update client information";
        showToast(errorMessage, "error");
        onError(error);
      },
      ...otherOptions,
    }
  );

  return { updateClientPersonalInfo: mutate, isUpdating: isLoading, ...rest };
};
